import { render, staticRenderFns } from "./WeChatNewsInfo.vue?vue&type=template&id=065d3fc6&scoped=true&"
import script from "./WeChatNewsInfo.vue?vue&type=script&lang=js&"
export * from "./WeChatNewsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065d3fc6",
  null
  
)

export default component.exports